import { resolveV3 } from '@/endpoints/resolveV3';
import DataResponse from '@/endpoints/types';

export type GenerateAerialReportResponse = {
  id: number;
  requested_at: string;
  created_at: string | null;
  report_type: string;
  status: string;
  name: string;
  file: string;
};

export async function generateAerialReport(
  data: FormData
): Promise<DataResponse<GenerateAerialReportResponse>> {
  return resolveV3(
    {
      data,
      method: 'POST',
      url: `/reports/pdfs/aerial/`,
    },
    {
      baseUrl: 'itasca',
    }
  );
}
